import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/apiClient";
import type { CalendarSummary, DashboardSummary, PeriodSummary, SummaryPeriod } from "./types";

export function useDashboardSummary() {
  return useQuery({
    queryKey: ["dashboard-summary"],
    queryFn: () => apiFetch<DashboardSummary>("/dashboard/summary"),
  });
}

export function usePeriodSummary(period: SummaryPeriod, options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["period-summary", period],
    queryFn: () => apiFetch<PeriodSummary>(`/dashboard/period-summary?period=${period}`),
    enabled: options.enabled,
  });
}

export function useCalendarSummary(year: number, month: number, options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["calendar-summary", year, month],
    queryFn: () => apiFetch<CalendarSummary>(`/dashboard/calendar?year=${year}&month=${month}`),
    enabled: options.enabled,
  });
}
